<template>
  <content-panel>
    <template v-slot:search>
      <search-box class="search-box">
        <el-form :inline="true" size="mini" label-width="80px" :model="searchForm" :rules="rules" ref="searchForm">
          <el-form-item label="商品编码" prop="goodsCode">
            <el-input v-model="searchForm.goodsCode" clearable @keyup.enter.native="onSearch"></el-input>
          </el-form-item>
          <el-form-item label="商品名称" prop="goodsName">
            <el-input v-model="searchForm.goodsName" clearable @keyup.enter.native="onSearch"></el-input>
          </el-form-item>
          <el-form-item label="审核状态">
            <el-select v-model="searchForm.status" clearable @change="onSearch">
              <el-option label="待审核" value="0" />
              <el-option label="通过" value="1" />
              <el-option label="拒绝" value="-1" />
            </el-select>
          </el-form-item>
          <el-form-item label="审核人员" prop="updatedBy">
            <el-input v-model="searchForm.updatedBy" clearable @keyup.enter.native="onSearch"></el-input>
          </el-form-item>
          <el-form-item label="审核时间">
            <form-date-range
              :form="searchForm"
              startKey="updatedDateStart"
              :usingTime="false"
              endKey="updatedDateEnd"
              valueFormat="yyyyMMdd"
            ></form-date-range>
          </el-form-item>
        </el-form>
        <template v-slot:right>
          <el-button class="green-btn" size="mini" @click="onSearch">搜索</el-button>
          <el-button class="orange-btn" size="mini" @click="reset">重置</el-button>
        </template>
      </search-box>
    </template>

    <table-panel ref="tablePanel">
      <template v-slot:header-right>
        <el-button type="primary" size="small" @click="adoptBatch" v-permission="`ec-pc-new#ec-pc-new#specialLiveManage#pass`">批量通过</el-button>
        <el-button type="primary" size="small" @click="exportExcel">导出</el-button>
        <el-button type="primary" size="small" @click="importExcel">导入申请</el-button>
        <el-button type="primary" size="small" @click="addLivePrice">新增申请</el-button>
      </template>
      <el-table
        stripe
        border
        ref="tableRef"
        :header-cell-style="{ backgroundColor: '#F4F8FB' }"
        highlight-current-row
        :data="tableData.list"
        :height="maxTableHeight"
        @selection-change="handleSelectionChange"
        v-if="tableReload"
        v-loading="loading"
      >
        <el-table-column type="selection" width="39" :selectable="rowSelectable"></el-table-column>
        <el-table-column prop="goodsCode" label="商品编码" min-width="120" show-overflow-tooltip></el-table-column>
        <el-table-column prop="goodsName" label="商品名称" min-width="200" show-overflow-tooltip></el-table-column>
        <el-table-column prop="livePrice" label="特殊直播价" min-width="100" align="center"></el-table-column>
        <el-table-column prop="liveRebate" label="直播佣金" min-width="80" align="center"></el-table-column>
        <el-table-column prop="maxLiveRebate" label="最高佣金" min-width="80" align="center"></el-table-column>
        <el-table-column prop="settlementPrice10" label="极限价10%" min-width="110" align="center"></el-table-column>
        <el-table-column prop="settlementPrice15" label="极限价15%" min-width="110" align="center"></el-table-column>
        <el-table-column prop="settlementPrice20" label="极限价20%" min-width="110" align="center"></el-table-column>
        <el-table-column prop="createdBy" label="申请人" min-width="80" align="center"></el-table-column>
        <el-table-column prop="reason" label="申请原因" min-width="100" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="status" label="审核状态" min-width="80" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="refuseReason" label="拒绝原因" min-width="150" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="minLivePrice" label="最低直播价" min-width="100" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="approveUser" label="审核人员" min-width="80" align="center"></el-table-column>
        <el-table-column prop="approveDate" label="审核时间" min-width="150" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column label="操作" fixed="right" align="center" width="100">
          <template slot-scope="{ row }">
            <el-button type="text" @click="adopt(row)" v-show="row.status == '待审核'" v-permission="`ec-pc-new#ec-pc-new#specialLiveManage#pass`">通过</el-button>
            <el-button type="text" @click="refuse(row)" v-show="row.status == '待审核'" v-permission="`ec-pc-new#ec-pc-new#specialLiveManage#refuse`" style="color: red">拒绝</el-button>
          </template>
        </el-table-column>
      </el-table>
      <template v-slot:footer>
        <div style="text-align: right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.pageNum"
            :page-sizes="[30, 60, 90]"
            :page-size="tableData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            background
            :total="tableData.total"
          ></el-pagination>
        </div>
      </template>
    </table-panel>
    <refuse-dialog :visible.sync="refuseVisible" :rowData="rowData" @success="onSearch" v-if="refuseVisible" />
    <new-application-dialog :visible.sync="newApplicationVisible" :rowData="rowData" @success="onSearch" v-if="newApplicationVisible" />
  </content-panel>
</template>

<script>
import tableMixin from '@/utils/tableMixin';
import pagePathMixin from '@/utils/page-path-mixin';
import refuseDialog from './components/refuse-dialog';
import newApplicationDialog from './components/new-application-dialog';
export default {
  name: 'specialLiveManage',
  mixins: [tableMixin, pagePathMixin],
  components: { refuseDialog, newApplicationDialog },
  data() {
    return {
      loading: false,
      tableData: {
        list: [],
        pageNum: 1,
        pageSize: 30,
        total: 0,
      },
      tableReload: true,
      newApplicationVisible: false,
      refuseVisible: false,
      searchFormData: [],
      multipleSelection: [],
      rules: {},
      searchForm: {
        goodsCode: '',
        goodsName: '',
        updatedBy: '',
        updatedDateStart: '',
        updatedDateEnd: '',
        status: '',
      },
      rowData: {},
    };
  },
  mounted() {
    this.onSearch();
  },
  methods: {
    onSearch() {
      this.tableData.pageNum = 1;
      this.init();
    },
    async init() {
      this.loading = true;
      let { updatedDateStart, updatedDateEnd } = this.searchForm;
      let data = {
        pageNum: this.tableData.pageNum,
        pageSize: this.tableData.pageSize,
        filterData: {
          ...this.searchForm,
          updatedDateStart: updatedDateStart ? updatedDateStart + ' 00:00:00' : '',
          updatedDateEnd: updatedDateEnd ? updatedDateEnd + ' 23:59:59' : '',
        },
      };
      this.searchFormData = data;
      this.$q.goods
        .goodsSpecialLivePricePage({ data: data })
        .then(res => {
          if (res.code == 200) {
            this.tableData = res.data;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 分页器 pagesize
    handleSizeChange(val) {
      this.tableData.pageSize = val;
      this.tableData.pageNum = 1;
      this.init();
    },
    // 分页器 pageNum
    handleCurrentChange(val) {
      this.tableData.pageNum = val;
      this.init();
    },

    reset() {
      this.$refs.searchForm.resetFields();
      this.tableData.pageNum = 1;
      this.onSearch();
    },

    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 行勾选禁用逻辑：只有待审核状态才能勾选
    rowSelectable(row) {
      return row.status === '待审核';
    },
    // 新增申请
    addLivePrice(row) {
      this.rowData = { ...row };
      this.newApplicationVisible = true;
    },

    // 批量通过
    async adoptBatch() {
      if (!this.multipleSelection.length) {
        this.$message.error('请选择对应的商品在进行操作!');
        return;
      }
      let data = this.multipleSelection.map(v => v.id);
      let status = await this.$confirm('是否确认通过？', '提示', { type: 'warning' });
      if (status !== 'confirm') return;
      this.$q.goods.goodsLiveSpecialPriceBatchApprove({ data: data }).then(res => {
        if (res.success) {
          this.$message.success('批量同意成功');
        }
        this.onSearch();
      });
    },
    // 通过
    async adopt(row) {
      let data = {
        id: row.id,
        batchCode: row.batchCode,
        status: 1,
      };
      let status = await this.$confirm('是否确认通过？', '提示', { type: 'warning' });
      if (status !== 'confirm') return;
      this.$q.goods.goodsLiveSpecialPriceApprove({ data: data }).then(res => {
        if (res.success) {
          this.$message.success('通过成功');
        }
        this.onSearch();
      });
    },

    // 拒绝
    refuse(row) {
      this.rowData = {...row};
      this.refuseVisible = true;
    },
    //导入
    importExcel() {
      this.openSubPage({
        path: '/goods/specialLiveManageImport',
        query: {
          fileName: '商品特殊直播价导入.xlsx',
          appCode: 'ec-pc-new',
          reportName: 'goodsSpecialLivePriceImport',
        },
      });
    },
    // 导出
    exportExcel() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      });
      let params = {
        appCode: 'ec-pc-new',
        paramMap: {
          ...this.searchFormData.filterData,
        },
        reportName: 'goodsSpecialLivePricePage',
      };
      this.$q.common
        .exportExcel({ data: params })
        .then(res => {
          if (res.success) {
            this.$message.success('提交下载任务成功，请稍后到导出列表查阅！');
          } else {
            this.$message.error(res.message);
          }
        })
        .finally(_ => {
          loading.close();
        });
    },
  },
  filters: {
    cellValFormat(val) {
      if (val) {
        return val;
      } else {
        if (isNaN(val) || val == 0) {
          return val;
        } else {
          return '--';
        }
      }
    },
    statusText(val) {
      if (val == 0) {
        return '待审核';
      } else if (val == 1) {
        return '通过';
      } else if (val == -1) {
        return '拒绝';
      } else if (val == 2) {
        return '已释放';
      }
    }
  },
};
</script>

<style lang="stylus" scoped>
.search-box {
  >>> .el-date-editor.el-input__inner, >>> .el-select, >>> .el-input {
    width: 240px !important;
  }
}

>>> .date-range .single-date {
  width: 110px !important;
}

>>> .form-number-input .el-input-number {
  width: 105px !important;
}

>>> .form-number-input .el-input-number .el-input {
  width: 105px !important;
}
</style>
